module.exports = __webpack_public_path__ + "static/sport/banner3.ed014d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/banner3.png
// module id = 9TAx
// module chunks = 0